module.exports = __webpack_public_path__ + "assets/img/knowledge.65e8cdfa.png";